export default __webpack_public_path__ + "static/media/howtouse_01.82e36d11.png";